module.exports = __webpack_public_path__ + "img/mustek.215fd468.png";